var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{class:[_vm.iframeClasses],attrs:{"width":_vm.iframeWidth,"height":_vm.iframeHeight,"src":_vm.iframeSrc,"title":_vm.iframeTitle,"frameborder":"0","allow":_vm.iframeAllowData,"allowfullscreen":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }